[
  {
    "id": "122a1203-3d26-71b2-819a-124131fe1ac6",
    "scanDate": "2025-12-11T12:00:00Z",
    "floor": 1
  }
]